module.exports = __webpack_public_path__ + "static/media/myntra-icon.f51cb56d.svg";